import { fetchRestResponse } from '../../../common/fetch/fetch-rest-reponse';
import { logger } from '../../../common/utils/logger';
import type { ObjectResolverDataType, ObjectResolverParamType } from './types';

const OBJECT_RESOLVER_ENDPOINT = '/gateway/api/object-resolver/resolve/batch';

export const fetchObjectResolver: (url: string) => Promise<import('./types').Data | null> = async (
	url: string,
) => {
	try {
		const objectResolver = await fetchRestResponse<
			ObjectResolverParamType[],
			ObjectResolverDataType[]
		>({
			url: OBJECT_RESOLVER_ENDPOINT,
			body: [{ resourceUrl: url }],
		});

		if (!objectResolver || objectResolver[0]?.status !== 200) {
			logger.warning({
				feature: 'bookmarks',
				element: 'container',
				operation: 'fetch',
				category: 'network',
				message: 'Object resolver returned a non-success response',
				errorCode: objectResolver?.[0]?.status,
				legacyError: 'REQUEST ERROR',
				functionName: 'convertToKeyPhraseInputFormat',
			});
			return null;
		}

		return objectResolver[0].body.data;
	} catch (error) {
		logger.error({
			feature: 'bookmarks',
			element: 'container',
			operation: 'fetch',
			category: 'network',
			error,
			functionName: 'convertToKeyPhraseInputFormat',
		});
		return null;
	}
};
